
<template>
  <div>
  <CModal
     :title="'OCR修正'"
     color="dark"
     :show.sync="recordModal"
     size='xl'
   >
    <CRow>
     <CCol sm="3" class="overflow-auto height-1000">
       <CRow class="form-box">
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">求人番号</label>
            <CInput
              v-model="$v.record['job_number'].$model"
              :class="{ 'is-invalid': $v.record['job_number'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['job_number'].NumberAndDashValidator">数字のみご記入ください／スペースは削除してください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3'>
            <label class="record-label auto-fix">企業名</label>
            <CInput
              v-model="$v.record['name'].$model"
              :disabled="!isVisible"
            />
          </CCol>
          <CCol sm="12" class='pr-0 mb-3'>
            <label class="record-label">事業所名フリガナ</label>
            <p class="caption">※カブシキガイシャ、イッパンシャダンホウジン、イリョウホウジンなどの法人名称は抜いてください</p>
            <CInput
              v-model="$v.record['name_kana'].$model"
            />
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">所在地の郵便番号</label>
            <CInput
              v-model="$v.record['postal_code'].$model"
              :class="{ 'is-invalid': $v.record['postal_code'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['postal_code'].OnlyNumberValidator">数字のみご記入ください（〒、ハイフンは不要です）</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">本社所在地</label>
            <CInput
              v-model="$v.record['address'].$model"
            />
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">従業員数（企業全体）</label>
            <CInput
              v-model="$v.record['employee_number'].$model"
              :class="{ 'is-invalid': $v.record['employee_number'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['employee_number'].OnlyNumberValidator">数字のみご記入ください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">従業員数(就業場所)</label>
            <CInput
              v-model="$v.record['work_employee_number'].$model"
              :class="{ 'is-invalid': $v.record['work_employee_number'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['work_employee_number'].OnlyNumberValidator">数字のみご記入ください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label">就業場所住所</label>
            <CTextarea
              v-model="$v.record['working_address'].$model"
              rows="5"
            />
          </CCol>

          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">職種</label>
            <CTextarea
              v-model="$v.record['working_style'].$model"
              rows="5"
            />
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">求人数（通勤）</label>
            <CInput
              v-model="$v.record['recruitment_numbers_commute'].$model"
              :class="{ 'is-invalid': $v.record['recruitment_numbers_commute'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['recruitment_numbers_commute'].OnlyNumberValidator">数字のみご記入ください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">求人数（住込）</label>
            <CInput
              v-model="$v.record['recruitment_numbers_live_in'].$model"
              :class="{ 'is-invalid': $v.record['recruitment_numbers_live_in'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['recruitment_numbers_live_in'].OnlyNumberValidator">数字のみご記入ください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">求人数（不問）</label>
            <CInput
              v-model="$v.record['recruitment_numbers_either'].$model"
              :class="{ 'is-invalid': $v.record['recruitment_numbers_either'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['recruitment_numbers_either'].OnlyNumberValidator">数字のみご記入ください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3'>
            <label class="record-label">必要な知識・技能等（履修科目）</label>
            <CTextarea
              v-model="$v.record['knowledge_and_skills'].$model"
              rows="5"
            />
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">毎月の賃金（月額）</label>
            <CInput
              v-model="$v.record['salary'].$model"
              :class="{ 'is-invalid': $v.record['salary'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['salary'].OnlyNumberValidator">数字のみご記入ください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3'>
            <label class="record-label">年間休日数</label>
            <CInput
              v-model="$v.record['holiday'].$model"
              :class="{ 'is-invalid': $v.record['holiday'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['holiday'].OnlyNumberValidator">数字のみご記入ください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3'>
            <label class="record-label">複数応募</label>
            <CInput
              v-model="$v.record['multiple_application'].$model"
            />
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">担当者氏名</label>
            <CInput
              v-model="$v.record['hr_contact_name'].$model"
            />
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">電話番号</label>
            <CInput
              v-model="$v.record['tel_number'].$model"
              :class="{ 'is-invalid': $v.record['tel_number'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['tel_number'].PhoneNumberValidator">数字のみご記入ください／ハイフンもご記入ください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3' v-if="isVisible">
            <label class="record-label auto-fix">FAX番号</label>
            <CInput
              v-model="$v.record['fax_number'].$model"
              :class="{ 'is-invalid': $v.record['fax_number'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['fax_number'].PhoneNumberValidator">数字のみご記入ください／ハイフンもご記入ください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3'>
            <label class="record-label">産業分類（コード）</label>
            <CInput
              v-model="$v.record['industry_class'].$model"
              :class="{ 'is-invalid': $v.record['industry_class'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['industry_class'].OnlyNumberValidator">数字のみご記入ください／スペースは削除してください</div>
          </CCol>
          <CCol sm="12" class='pr-0 mb-3'>
            <label class="record-label">職業分類（コード）</label>
            <p class="caption">※1つ目のみご記入ください</p>
            <CInput
              v-model="$v.record['job_class_one'].$model"
              :class="{ 'is-invalid': $v.record['job_class_one'].$error }"
            />
            <div class="error my-2" v-if="!$v.record['job_class_one'].NumberOrDashValidator">数字とハイフンのみご記入ください／スペースは削除してください</div>
          </CCol>
       </CRow>
     </CCol>
     <CCol sm="8" class='text-center mx-auto px-0 overflow-auto height-1000'>
        <img :src="record['job_image_0']" class="w100"/>
        <img :src="record['job_image_1']" class="w100"/>
     </CCol>
   </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">閉じる</CButton>
       </template>
   </CModal>

   <CModal
     :title="'管理ステータス修正'"
     color="dark"
     :closeOnBackdrop=false
     :show.sync="checkModal"
   >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">管理ステータス</label>
           <CSelect
             :options="manageSelect"
             :value.sync="record.manage_status"
           />
         </CCol>
       </CRow>

       <CRow v-if="isAdmin" class="form-box">
         <CCol sm="12">
           <label class="record-label">求人票DataBox表示</label>
           <CSelect
             :options="publicSelect"
             :value.sync="record.is_org_public"
           />
         </CCol>
       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem()">登録</CButton>
       </template>
   </CModal>
 </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { helpers } from 'vuelidate/lib/validators'

const NumberAndDashValidator = helpers.regex('NumberAndDashValidator', /^[0-9０-９]+[-―－ー‐][0-9０-９]+$/);
const OnlyNumberValidator = helpers.regex('OnlyNumberValidator', /^[0-9０-９]+$/);
const PhoneNumberValidator = helpers.regex('OnlyNumberValidator', /^[0-9０-９]+[-―－ー‐][0-9０-９]+[-―－ー‐]+[0-9０-９]+$/);
const NumberOrDashValidator = helpers.regex('NumberOrDashValidator', /^[0-9０-９]*[-―－ー‐]*[0-9０-９]*$/);

// var loadingTask = pdf.createLoadingTask('https://cdn.mozilla.net/pdfjs/tracemonkey.pdf');
export default {
  name: '',
  components: {
  },
  props: {
    record:{},
    recordModal: {
      type: Boolean,
      default: false
    },
    updateMode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      checkModal: false,
      numPages: undefined,
      manageSelect: [
        { value: "", label: "--"},
        { value: "fix", label: "修正済"},
        { value: "not_fix", label: "未修正"},
        { value: "not_parseable", label: "解析不可"},
        { value: "auto_fix", label: "反映済"},
      ],
      publicSelect: [
        { value: true, label: "公開"},
        { value: false, label: "非公開"},
      ],
    }
  },
  validations: {
    record: {
      job_number: {
        NumberAndDashValidator
      },
      name: {
      },
      name_kana: {
      },
      postal_code: {
        OnlyNumberValidator
      },
      address: {
      },
      access: {
      },
      corporate_number: {
      },
      employee_number: {
        OnlyNumberValidator
      },
      work_employee_number: {
        OnlyNumberValidator
      },
      established: {
      },
      capital: {

      },
      description: {
      },
      feature: {
      },
      job_description: {
      },
      working_address_postal_code: {

      },
      working_address: {
      },
      working_address_access: {
      },
      working_style: {
      },
      recruitment_numbers_commute: {
        OnlyNumberValidator
      },
      recruitment_numbers_live_in: {
        OnlyNumberValidator
      },
      recruitment_numbers_either: {
        OnlyNumberValidator
      },
      knowledge_and_skills: {
      },
      salary: {
        OnlyNumberValidator
      },
      holiday: {
        OnlyNumberValidator
      },
      multiple_application: {
      },
      interview_venue_postal_code: {
        OnlyNumberValidator
      },
      interview_venue: {
      },
      interview_venue_access: {
      },
      hr_contact_position: {
      },
      hr_contact_name: {
      },
      tel_number: {
        PhoneNumberValidator
      },
      fax_number: {
        PhoneNumberValidator
      },
      industry_class: {
        OnlyNumberValidator
      },
      job_class_one: {
        NumberOrDashValidator
      },
    }
  },
  methods: {
    showCheckModal(){
      this.$v.$touch()
      if (this.$v.$invalid) {
        alert('入力エラーがあります。赤枠になっている項目をご確認ください。')
      } else {
        this.checkModal = true
        this.$emit('hide')
        this.recordModal = false
      }
    },
    hideRecordModal: function() {
        this.checkModal = false
        this.recordModal = false
        this.$emit('hide')
    },
    convertToHalf(e) {
      return e.replace(/[！-～]/g, halfWidthChar => String.fromCharCode(halfWidthChar.charCodeAt(0) - 0xfee0)).replace(/[-―－ー‐]/g, "-");
    },
    updateItem: function() {
      if(!this.$v.record.$error) {
        this.record.edit_at = moment().format("YYYY/MM/DD")
        Object.keys(this.record).forEach(key => {
          if(this.record[key] && (key == "job_number" || key == "postal_code" || key == "corporate_number" || key == "employee_number" || key == "work_employee_number" || key == "established" || key == "working_address_postal_code" || key == "recruitment_numbers_commute" || key == "recruitment_numbers_live_in" || key == "recruitment_numbers_either" || key == "salary" || key == "holiday" || key == "interview_venue_postal_code" || key == "tel_number" || key == "fax_number" || key == "industry_class" || key == "job_class_one" || key == "capital")) {
              this.record[key] = this.convertToHalf(this.record[key].toString())
          }
        });
        axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/api/mng/jobs/" + this.record.id, {"job": this.record, "update_type": this.updateMode}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.notifyVue("更新されました")
          this.checkModal = false
          this.$emit('update', this.record)
        }).catch(error => {
          console.log(error)
        })
      }
    }
  },
  mounted() {},
  watch: {
    record: {
      handler: function () {
        this.$v.record.$touch();
      },
      deep: true
    },
    recordModal: function(){
      if(this.recordModal == false){
        this.$v.$touch()
        if (this.$v.$invalid) {
          alert('入力エラーがあります。赤枠になっている項目をご確認ください。')
          this.recordModal = true
        } else {
          this.$emit('hide')
          this.checkModal = true
          this.numPages = undefined
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
      role: 'GetRole',
    }),
    isAdmin() {
      return this.role == 'super_admin' || this.role == 'admin'
    },
    isVisible() {
      if (this.isAdmin) {
        return true
      }
      // 権限がメンバーで管理ステータスが反映済みの場合、特定の項目のみ表示
      if (this.record.manage_status === 'auto_fix') {
        return false
      } else {
        return true
      }
    }
  },
}
</script>

<style scoped lang="scss">
.caption {
  font-size: 11px;
  margin-bottom: 0.5rem;
}
.auto-fix {
  color: rgb(255, 153, 0);
}
.error{
  color: red;
}
.height-1000 {
  height: 1000px;
}
.w100 {
  width: 100%;
}
</style>
